import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-end-page',
  templateUrl: './end-page.component.html',
  styleUrls: ['./end-page.component.scss']
})
export class EndPageComponent implements OnInit {

  requiredDocs: string[] = ["תלושי משכורת ודפי חשבון מ-3 החודשים האחרונים",
                            "תעודת זהות", 
                            "העתק חוזה ונסח טאבו", 
                            "דוגמת צ'ק"];

  constructor() { }

  ngOnInit() {
	window.scrollTo(0, 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/end-page/end-page.component.ts